﻿<template>
    <section class="conf-docs">
        <h3>Travel documents</h3>
        <p>Please check the booking details carefully and read through all the travel documents before going on your tour.</p>
        <div class="conf-doc-list">
            <documentation_item v-for="(document, index) in get_documents()" :key="index" :document="document" :index="index"></documentation_item>
        </div>
    </section>
</template>

<script lang="ts" src="./documentation.ts"></script>